import comp from "./OfflineOverlayHOC";
export default comp;
